<template>
  <div class="tms-dashboard wp-dashboard-route">
    <div class="content-body">
      <div class="nav-bar-container">
        <div class="nav-bar clearfix">
          <div class="welcome">
            <span class="summary-hello">{{ $t("hello") }}</span>
            <span class="summary-name">{{ (currentUserContact || {}).name || currentUser.name }}</span>
          </div>
          <div class="summary-items" />
        </div>
      </div>

      <div class="tenant-dashboard__wrapper">
        <WorkPermitTable :key="componentKey" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SwitchRegionsEventMixin from '@/modules/SwitchRegionsEventMixin'
import WorkPermitTable from '@/modules/dashboards/WorkPermitTable'
import viewAllCommonTableSnapshotMixin from '@/mixins/viewAllCommonTableSnapshot.mixin'
import { ENGINEER_WP_DASHBOARD_LEAVE_PRESERVE_ROUTE_NAMES } from '@/constants/viewAllTableCache'

export default {
  name: 'DashBoardWorkPermitView',
  /**
   * Custom `<table>` in WorkPermitTable; register same snapshot id so Vuex `tables` purge/remove matches other view-all flows.
   * @see `@/mixins/viewAllCommonTableSnapshot.mixin.js`
   */
  viewAllTableSnapshotId: 'work-permit-dashboard-table',
  viewAllTableLeavePreserveRouteNames: ENGINEER_WP_DASHBOARD_LEAVE_PRESERVE_ROUTE_NAMES,
  components: {
    WorkPermitTable,
  },
  mixins: [SwitchRegionsEventMixin, viewAllCommonTableSnapshotMixin],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  computed: {
    ...mapGetters('user', ['currentUser', 'currentUserContact']),
  },
}
</script>

<style lang="scss">
@import '~styles/dashboard/tmsdashboard';
</style>

<style lang="scss" scoped>
/*
 * Moved from assets/styles/styles.scss: parent shell must allow overflow-visible for nested dashboard UI.
 */
.tms-dashboard.wp-dashboard-route {
  overflow: visible;
}
</style>
